// extracted by mini-css-extract-plugin
module.exports = {"Actions":"StoreIntegrationCheckWarning_Actions__3suyH"};